module.exports = __webpack_public_path__ + "img/aws.f9b3b15c.png";